export enum StockCode {
    REVENDIQUE = 'REVENDIQUE',
    ISSU_DR = 'ISSU_DR'
}
